import React, { useCallback } from "react"
import { IconButton, Menu, MenuItem } from "@material-ui/core"
import { Person as PersonIcon } from "@material-ui/icons"
import SnackContext from "./Snackbar"
import { ChannelData } from "@root/store/types"

export interface Props {
  channel: Required<ChannelData>
  onOptOut: () => void
  onOptIn: () => void
}

const ChannelPopover: React.FC<Props> = ({ channel, onOptOut, onOptIn }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const { createSnack } = React.useContext(SnackContext)

  const optIn = useCallback(() => {
    onOptIn()
    setAnchorEl(null)
  }, [onOptIn, setAnchorEl])
  const optOut = useCallback(() => {
    onOptOut()
    setAnchorEl(null)
  }, [onOptOut, setAnchorEl])

  return (
    <>
      <IconButton
        color="inherit"
        onClick={(ev) => setAnchorEl(ev.currentTarget)}
        aria-controls="channel-menu"
        aria-haspopup="true"
        aria-label="Channel"
        data-qa-selector="channel-menu-button"
      >
        <PersonIcon />
      </IconButton>
      <Menu
        id="channel-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            createSnack("Channel ID copied to clipboard")
            navigator.clipboard.writeText(channel.id)
          }}
          data-qa-selector="channel-id"
        >
          {channel.id}
        </MenuItem>
        {channel.optIn ? (
          <MenuItem data-qa-selector="opt-out" onClick={optOut}>
            Opt Out
          </MenuItem>
        ) : (
          <MenuItem data-qa-selector="opt-in" onClick={optIn}>
            Opt In
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default ChannelPopover
